import {AsyncGenericEntityForm} from "../../forms";
import {ComposedExtractedAttribute, DefaultExtractedAttribute} from "../selected-node/api/ExtractedAttribute";
import {FormContextModal} from "./FormContextModal";
import {message, Spin} from "antd";
import {ExtractedConstructionType} from "../selected-node/api/ExtractedConstructionType";
import {useState} from "react";
import {GeneratedName} from "../../../services/GeneratedName";


const extractedAttributes = new ComposedExtractedAttribute([
	new DefaultExtractedAttribute(),
	new ExtractedConstructionType(),
]);


const emptyFlocAttributes = async () => {
	const name = await new GeneratedName("floc").value();
	const data = {
		entity_id: name,
		description: '',
		construction_type_name: null
	};
	return extractedAttributes.extract(data);
};


export function CreateFlocModal() {
	const [loading, setLoading] = useState(false);

	return (
		<FormContextModal
			title={subject => `Create new FLOC under: ${subject.title}`}
			expectedType={'create_floc'}
			formId={"create-floc-modal"}
			okText={"Create"}
			modalRender={node => (
				<Spin spinning={loading}>
					{node}
				</Spin>
			)}
		>
			{(subject, close, formId) => (
				<AsyncGenericEntityForm
					id={formId}
					attributesSource={emptyFlocAttributes}
					setLoading={setLoading}
					onFinish={
						values => subject.handle(values).then(
							_ => close()
						).catch(() => message.error('Failed to create new FLOC'))
					}
				/>
			)}
		</FormContextModal>
	);
}
